import type { HiveDocumentSelectionData } from '@gitbook/hive-client';

export const SELECTION_FOCUS = 'focus';
export const SELECTION_RANGE = 'range';

export interface RealtimeRangeData extends HiveDocumentSelectionData {
    userId: string;
    userDisplayName: string;
}
